export default __webpack_public_path__ + "static/media/e_kidd_online.70c18486.jpeg";